module.exports = __webpack_public_path__ + "img/in.aa424fe2.svg";